var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-file-input',_vm._b({attrs:{"prepend-inner-icon":"mdi-attachment","prepend-icon":"","value":_vm.modelValue,"id":_vm.id,"label":_vm.label,"disabled":_vm.disabled,"outlined":_vm.outlined,"dense":_vm.dense},on:{"change":(newValue) => (_vm.modelValue = newValue)}},'v-file-input',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }